import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { Store } from '@ngrx/store';
import * as AuthActions from '../store/auth/auth.actions';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService, private store: Store) {}

  intercept(
    request: HttpRequest<any>,
    httpHandler: HttpHandler
  ): Observable<HttpEvent<any>> {
    return this.authService.getAccessToken().pipe(
      // Se não for possível obter o token, prossegue sem Authorization em vez de falhar a requisição.
      catchError(() => of(null)),
      switchMap((accessToken) => {
        const authRequest = accessToken
          ? request.clone({ setHeaders: { Authorization: `Bearer ${accessToken}` } })
          : request;

        return httpHandler
          .handle(authRequest)
          .pipe(catchError((error) => this.tratarErro(request, httpHandler, error)));
      })
    );
  }

  private tratarErro(
    request: HttpRequest<any>,
    httpHandler: HttpHandler,
    error: unknown
  ): Observable<HttpEvent<any>> {
    // Se o erro for 401 (Não autorizado), tenta renovar o token e refazer a requisição uma vez.
    if (error instanceof HttpErrorResponse && error.status === 401) {
      return this.authService.refreshToken().pipe(
        switchMap((accessToken) => {
          const authRequest = request.clone({
            setHeaders: { Authorization: `Bearer ${accessToken}` },
          });
          return httpHandler.handle(authRequest);
        }),
        catchError((refreshError) => {
          this.store.dispatch(AuthActions.logout());
          return throwError(() => refreshError);
        })
      );
    }

    // Para qualquer outro erro, repassa o erro original.
    return throwError(() => error);
  }
}
